import React from "react";
import { useTranslation } from "react-i18next";
import "./crm.css";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink.jsx";

const CRM_MoreServices = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=CRM";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("MORE_SERVICE_CRM_SUBTITLE"),
    text: t("MORE_SERVICE_CRM_DESCRIPTION"),
    className: "crmHeroBanner",
    chipText: "CRM",
  };

  const cardBenefitsData = [
    {
      title: t("MORE_SERVICE_CRM_LEAD_MANAGEMENT"),
      text: t("MORE_SERVICE_CRM_LEAD_MANAGEMENT_DESC"),
      icon: "investments.svg",
    },
    {
      title: t("MORE_SERVICE_CRM_CUSTOMER_INTERACTION_TRACKING"),
      text: t("MORE_SERVICE_CRM_CUSTOMER_INTERACTION_TRACKING_DESC"),
      icon: "interaction_tracking.svg",
    },
    {
      title: t("MORE_SERVICE_CRM_SALES_AUTOMATION"),
      text: t("MORE_SERVICE_CRM_SALES_AUTOMATION_DESC"),
      icon: "sales_automation.svg",
    },
    {
      title: t("MORE_SERVICE_CRM_ANALYTICS_REPORTING"),
      text: t("MORE_SERVICE_CRM_ANALYTICS_REPORTING_DESC"),
      icon: "analytics_reporting.svg",
    },
    {
      title: t("MORE_SERVICE_CRM_CUSTOMER_SUPPORT"),
      text: t("MORE_SERVICE_CRM_CUSTOMER_SUPPORT_DESC"),
      icon: "customer_support.svg",
    },
  ];

  const processData = [
    {
      title: t("MORE_SERVICE_CRM_UNDERSTAND_NEEDS"),
      text: t("MORE_SERVICE_CRM_UNDERSTAND_NEEDS_DESC"),
      img: "/img/woman-man-shake-hands-partners-made-deal-created-with-generative-ai-technology 1.jpg",
    },
    {
      title: t("MORE_SERVICE_CRM_CUSTOMIZE_SOLUTION"),
      text: t("MORE_SERVICE_CRM_CUSTOMIZE_SOLUTION_DESC"),
      img: "/img/young-adult-businessman-working-late-night-computer-technology-generated-by-artificial-intelligence 1.jpg",
    },
    {
      title: t("MORE_SERVICE_CRM_IMPLEMENT_TRAIN"),
      text: t("MORE_SERVICE_CRM_IMPLEMENT_TRAIN_DESC"),
      img: "/img/DreamShaper_v7_white_robot_giving_advices_to_a_business_man_on_3 2.jpg",
    },
    {
      title: t("MORE_SERVICE_CRM_ONGOING_SUPPORT"),
      text: t("MORE_SERVICE_CRM_ONGOING_SUPPORT_DESC"),
      img: "/img/dia-internacional-educacion-estilo-futurista-robots 1.jpg",
    },
  ];

  const keyData = [
    { title: t("MORE_SERVICE_CRM_CENTRALIZED_CUSTOMER_DATA") },
    { title: t("MORE_SERVICE_CRM_ENHANCED_CUSTOMER_ENGAGEMENT") },
    { title: t("MORE_SERVICE_CRM_IMPROVED_SALES_EFFICIENCY") },
    { title: t("MORE_SERVICE_CRM_DATA_DRIVEN_INSIGHTS") },
  ];

  function ProcessCard({ img, title, text, step }) {
    return (
      <article className="crmProcessCard">
        <div className="crmProcessMedia">
          <img src={img} alt={title} />
        </div>

        <div className="crmProcessContent">
          <div className="crmStepNumber">{step}</div>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  function BenefitCard({ text }) {
    return (
      <article className="crmBenefitCard">
        <p>{text}</p>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="crmPage">
        <section className="crmHero crmHeroFull">
          <div className="crmHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("MORE_SERVICE_CRM_CTA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="crmFeatures">
          <div className="crmFeaturesWrap">
            <div className="crmSectionIntro">
              <h2>{t("MORE_SERVICE_CRM_KEY_FEATURES_TITLE")}</h2>
              <p>{t("MORE_SERVICE_CRM_KEY_FEATURES_DESC")}</p>
            </div>

            <BenefitsCardsComponent title="" cardsData={cardBenefitsData} />
          </div>
        </section>

        <section className="crmProcess">
          <div className="crmSectionIntro">
            <h2>{t("MORE_SERVICE_CRM_PROCESS_TITLE")}</h2>
            <p>{t("MORE_SERVICE_CRM_PROCESS_DESC")}</p>
          </div>

          <div className="crmProcessTimeline">
            <div className="crmProcessGrid">
              {processData.map((process, index) => (
                <ProcessCard
                  key={index}
                  step={index + 1}
                  title={process.title}
                  text={process.text}
                  img={process.img}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="crmBenefits">
          <div className="crmBenefitsWrap">
            <div className="crmSectionIntro">
              <h2>{t("MORE_SERVICE_CRM_BENEFITS_TITLE")}</h2>
              <p>{t("MORE_SERVICE_CRM_BENEFITS_DESC")}</p>
            </div>

            <div className="crmBenefitsGrid">
              {keyData.map((benefit, index) => (
                <BenefitCard key={index} text={benefit.title} />
              ))}
            </div>
          </div>
        </section>

        <section className="crmCta">
          <div className="crmCtaInner">
            <div className="crmCtaContent">
              <h2>{t("MORE_SERVICE_CRM_FINAL_TITLE")}</h2>
              <div className="crmCtaText">
                <p>{t("MORE_SERVICE_CRM_FINAL_DESC")}</p>
              </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("MORE_SERVICE_CRM_CTA")}
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=CRM"
              }
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default CRM_MoreServices;